import { checkUserResourcePermissions } from 'sonata-static-storage/lib/helpers/user.helpers';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

export function hasContentCategoriesPermission(user: UserInterface, userRoles: UserRoleInterface[]): boolean {
  return (
    checkUserResourcePermissions('contentCategories', user, userRoles) ||
    checkUserResourcePermissions('iasCategories', user, userRoles)
  );
}
